import { IPasswordRuleOverride } from '../types/interfaces';

export const ES_USERNAME_MIN_LENGTH = 1;
export const ES_USERNAME_MAX_LENGTH = 60;
export const ES_PASSWORD_MIN_LENGTH = 8;

export const ES_USERNAME_LENGTH_CONSTRAINT = `${ES_USERNAME_MIN_LENGTH}-${ES_USERNAME_MAX_LENGTH} characters in length`;
export const ES_USERNAME_WARNING =
  "Usernames can't be changed after your account is created.";

export const ES_PASSWORD_RULES: IPasswordRuleOverride[] = [
  {
    constraint: `At least ${ES_PASSWORD_MIN_LENGTH} characters in length`,
    regex: `^.{${ES_PASSWORD_MIN_LENGTH},}$`,
  },
  { constraint: 'At least 1 uppercase character', regex: '[A-Z]' },
  { constraint: 'At least 1 number (0 through 9)', regex: '[0-9]' },
  {
    constraint:
      'At least 1 nonalphanumeric character: ~ ! @ # $ % ^ & * _ - + = ` | \\ ( ) { } [ ] : ; " \' < > , . ? /',
    regex: '[~!@#$%^&*_\\-+=`|\\\\(){}\\[\\]:;"\'<>,.?/]',
  },
];

export function isEnergyStarUsernameValid(username: string): boolean {
  return (
    username.length >= ES_USERNAME_MIN_LENGTH &&
    username.length <= ES_USERNAME_MAX_LENGTH
  );
}
